/**
 * Frontend route paths the backend must be able to redirect to.
 *
 * These are compiled routes, not configuration: the backend builds a redirect URL
 * and the frontend registers a matching route, so both sides must read the same
 * literal or an OAuth completion silently lands on the SPA catch-all.
 */

/** Where every external-connect flow (Google, Microsoft, Xero) returns the browser. */
export const EXTERNAL_CONNECT_COMPLETION_PATH = '/settings/integrations';
